import React from 'react';
import { MapPin } from 'lucide-react';
const countries = [{
  name: 'Colombia',
  color: '#DC2626'
}, {
  name: 'Spain',
  color: '#DC2626'
}, {
  name: 'United States',
  color: '#2563eb'
}, {
  name: 'Chile',
  color: '#2563eb'
}, {
  name: 'Peru',
  color: '#facc15'
}, {
  name: 'Argentina',
  color: '#e8e2d4'
}];
export function Dedication() {
  return <section className="bg-[#0a0a0a] py-12 sm:py-20 px-6 relative overflow-hidden" data-id="element-41">
      {/* Subtle ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#d4a85a]/[0.03] rounded-full blur-[140px] pointer-events-none" data-id="element-42" />

      <div className="max-w-3xl mx-auto text-center relative z-10 flex flex-col gap-6 sm:gap-10" data-id="element-43">
        {/* Top tag */}
        <div className="flex items-center justify-center gap-2 text-[#d4a85a] uppercase tracking-[0.25em] text-[11px] sm:text-xs font-semibold" data-id="element-44">
          <MapPin className="w-4 h-4" strokeWidth={2} data-id="element-45" />
          <span data-id="element-46">For those who had to leave</span>
        </div>

        {/* Main headline */}
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-[44px] text-[#d4a85a] font-normal leading-[1.2]" data-id="element-47">
          You are in another country,
          <br className="hidden sm:block" data-id="element-48" /> but Venezuela remains in you.
        </h2>

        {/* First paragraph — bold italic */}
        <p className="font-serif italic text-[#e8e2d4] text-lg sm:text-xl leading-[1.7] font-semibold" data-id="element-49">
          You left because there was no other choice. You left behind your
          mother, your friends, and the streets that saw you grow up. And even
          though you live on another continent today, there are nights when the
          weight of what happened crushes you.
        </p>

        {/* Second paragraph */}
        <p className="font-serif text-[#e8e2d4] text-lg sm:text-xl leading-[1.7] font-light" data-id="element-50">
          You are not alone. More than 7 million Venezuelans carry that same
          invisible backpack. This book is for all of us. It is the testimony of
          what we lived, of what we lost, and of why we must never forget.
        </p>

        {/* Final call */}
        <p className="font-serif text-[#e8e2d4] text-lg sm:text-xl leading-[1.7] font-light" data-id="element-51">
          Give it as a gift to those who don\'t understand why you left. Read it
          yourself when you need to remember that your story matters. Share it
          with your children so they know where they come from.
        </p>

        {/* Country dots */}
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-3 pt-8 text-sm text-gray-400" data-id="element-52">
          {countries.map(c => <div key={c.name} className="flex items-center gap-2" data-id="element-53">
              <span className="w-2 h-2 rounded-full inline-block" style={{
            backgroundColor: c.color,
            boxShadow: `0 0 6px ${c.color}80`
          }} data-id="element-54" />
              <span data-id="element-55">{c.name}</span>
            </div>)}
          <span className="text-gray-500 italic text-sm" data-id="element-56">
            and 12 more countries
          </span>
        </div>
      </div>
    </section>;
}